var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mainWrapper", attrs: { id: "top" } },
    [
      _c("head-nav", { attrs: { gray: _vm.gray, pos: "fixed" } }),
      _vm._v(" "),
      _vm.datum
        ? _c(
            "div",
            { staticClass: "innerWrapper" },
            [
              _c("h1", [_vm._v("Purchased properties")]),
              _vm._v(" "),
              _vm.datum.totalRecord == 0
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "padding-top": "80px",
                        "text-align": "center",
                        "font-size": "18px",
                        color: "#3F3F46",
                        "margin-bottom": "218px"
                      }
                    },
                    [_vm._v("\n      No data.\n    ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.datum.totalRecord !== 0
                ? _c("pagination", {
                    attrs: { cur: _vm.pageCur, total: _vm.datum.totalRecord },
                    on: { accept: _vm.page }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("ul", [
                _c(
                  "li",
                  _vm._l(_vm.datum.formatList, function(item, index) {
                    return _c("item", {
                      key: index,
                      attrs: {
                        btnNum: index + 1,
                        cur: _vm.pageCur,
                        datum: item,
                        tag: false
                      },
                      on: { accept: _vm.collectOperate }
                    })
                  }),
                  1
                )
              ]),
              _vm._v(" "),
              _vm.datum.totalRecord !== 0
                ? _c("pagination", {
                    attrs: { cur: _vm.pageCur, total: _vm.datum.totalRecord },
                    on: { accept: _vm.page }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("foot-nav")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ea686d9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea686d9a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/purchase.vue
// module id = null
// module chunks = 